export const SEVEN_DAYS = 1000 * 3600 * 24 * 7;
